<template>
    <div class="shopCartMain" @click.self="consoleInfo('main click')">
        <div class="frame">
            <div class="productSpecificationListFrameHeader">
                <div>已选商品</div>
                <div style="flex-grow:1;"></div>
                <button @click="clearCart">清空购物车</button>
            </div>
            <div class="horizonGully" style="flex-shrink:0;"/>
            <div class="horizonDivider" style="flex-shrink:0;"/>
            <div class="horizonGully" style="flex-shrink:0;"/>
 
            <div class="productSpecificationListFrameContent">
                <div v-for="(item, index) of productListAfterHandle" :key="item.productInfo.pId + '_' + item.specificationId">
                    <div style="display: flex;align-items: center;justify-content: center;font-size: 0.16rem;font-weight: 800;line-height: 2.8em;" v-if="item.yingqiyu_categoryName">
                        <div style="margin-right: 0.16rem;">{{ item.yingqiyu_categoryName }}</div>
                        <div style="position: relative;color: red;animation-name: my_blink;animation-duration: 0.1s;animation-iteration-count: 16;">{{ item.yingqiyu_warning }}</div>
                    </div>

                    <div class="productWrapper">
                        <input type="checkbox" class="selector" :checked="selectProductList[index]" @click="selectProduct(index)"/>
                        <ProductOfCart
                            class="productOfCart"
                            :shopId="shopId"
                            :productImg="item.productInfo.pPic_1"
                            :productName="item.productInfo.pName"
                            :productId="item.productInfo.pId"
                            :productPrice="item.productInfo.pNowPrice"
                            :productNumber="item.snum"
                            :specificationId="item.specificationId"
                            :specificationName="item.specificationName"
                            :shelfId="item.shelfId"
                            :stock="item.productInfo.pStock"
                        />
                    </div>
                </div>
            </div>

            <div class="productSpecificationListFrameBottom">
                <div class="horizonGully" />
                <div class="horizonDivider" />
                <div class="horizonGully" />
                <div @click="selectAll">
                    <input type="checkbox" id="selectAll" style="width: 2em;min-width: 0;" :checked="ifSelectAll"/>
                    <label for="selectAll" >全选</label>
                </div>
                <div class="horizonGully" />
                <div class="operatePanel">
                    <button @click="commitOrder"
                        >{{ commitOrderText }}</button
                    >
                    <div class="verticalGully" style="flex-shrink:0;"/>
                    <button @click="removeDialog"
                        >关闭</button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ProductOfCart from '@/components/cart/ProductOfCart.vue'
import { mapState, mapGetters, } from 'vuex'

import store from '@/store'
import router from '@/router'

export default {
    store: store,
    router: router,

    name: "ShopCartV2",

    components: { ProductOfCart },

    props: {
        shopId: {
            type: Number,
            required: true,
        },
    },

    data()
    {
        return {
            ifSelectAll: true,

            productListAfterHandle: [],
            productListWantPay: [],

            totalPrice: 0,
        }
    },

    computed: {
        ...mapState({
            cartInfoAll: (state) => state.cart.cartInfoAll,
            shopInfo: (state) => state.shop.shopInfo,
            shelfIdMapWithMaxBuyNum: state => {
                let shelfIdMapWithMaxBuyNumTmp = {};

                for(let item of state.order.shelfIdListWithMaxBuyNum)
                {
                    shelfIdMapWithMaxBuyNumTmp[item.id] = item;
                }

                return shelfIdMapWithMaxBuyNumTmp;
            },
        }),

        ...mapGetters('cart', [
            'getCartInfo',
        ]),

        commitOrderText() {
            if (this.shopInfo.ifBusiness == 1) {
                return '店铺已暂停营业'
            }

            for(let item of this.productListWantPay)
            {
                if(item.yingqiyu_warning)
                {
                    return `${item.yingqiyu_categoryName} ${item.yingqiyu_warning}`
                }
            }
            
            return `立即结算 ￥${this.lodash.round(this.totalPrice, 2)}`;
        },

        cartInfo() {
            if(this.cartInfoAll && process.env.NODE_ENV == 'development')
            {
                console.log('shopCart, cartInfoAll changed')
            }

            //
            return this.getCartInfo(this.shopId);
        },

        selectProductList() {
            return this.cartInfo.shoppingCars.map(el => true);
        },
    },

    watch: {
        cartInfo()
        {   
            //
            this.computeTotalPrice();
        },
    },

    created() {
        //
        this.computeTotalPrice();
    },

    methods: {
        computeTotalPrice()
        {
            this.productListAfterHandle = JSON.parse(JSON.stringify(this.cartInfo.shoppingCars));
            this.productListAfterHandle = this.productListAfterHandle.sort((a, b) => {
                return a.shelfId[0] - b.shelfId[0];
            });

            //
            let preCategoryId = null;
            this.productListAfterHandle.forEach(el => {
                //
                el.yingqiyu_categoryName = null;
                el.yingqiyu_categoryTotalPrice = null;
                el.yingqiyu_warning = null;

                /**
                 * 
                 */
                if(el.shelfId[0] != preCategoryId)
                {
                    //
                    el.yingqiyu_categoryName = this.shelfIdMapWithMaxBuyNum[el.shelfId[0]].shelfName;
                    
                    //
                    preCategoryId = el.shelfId[0];
                }
            });

            /**
             * 
             */
            this.productListWantPay = [];
            this.totalPrice = 0;
            //
            for(let index = 0; index < this.selectProductList.length; index ++)
            {
                if(this.selectProductList[index] == true)
                {
                    this.productListWantPay.push(this.productListAfterHandle[index]);

                    this.totalPrice += this.productListAfterHandle[index].productInfo.pNowPrice * this.productListAfterHandle[index].snum;
                }
            }

            preCategoryId = null;
            let firstCategoryProduct = null;
            this.productListWantPay.forEach(el => {
                if(el.shelfId[0] != preCategoryId)
                {
                    /**
                     * 
                     */
                    if(firstCategoryProduct)
                    {
                        if(this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice == "")
                        {
                            this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice = this.shopInfo.minimallyBuyPrice;
                        }
                        else
                        {
                            this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice = parseInt(this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice);
                        }
                        
                        if(firstCategoryProduct.yingqiyu_categoryTotalPrice < this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice)
                        {
                            firstCategoryProduct.yingqiyu_warning = `差${this.lodash.round(
                                this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice - firstCategoryProduct.yingqiyu_categoryTotalPrice,
                                2
                            )}元起送`;
                        }
                    }

                    /**
                     * 
                     */
                    el.yingqiyu_categoryTotalPrice = 0;

                    //
                    firstCategoryProduct = el;

                    //
                    preCategoryId = el.shelfId[0];
                }

                firstCategoryProduct.yingqiyu_categoryTotalPrice += el.productInfo.pNowPrice * el.snum;
            });

            /**
             * 
             */
            if(firstCategoryProduct)
            {
                if(this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice == "")
                {
                    this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice = this.shopInfo.minimallyBuyPrice;
                }
                else
                {
                    this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice = parseInt(this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice);
                }

                if(firstCategoryProduct.yingqiyu_categoryTotalPrice < this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice)
                {
                    firstCategoryProduct.yingqiyu_warning = `差${this.lodash.round(
                        this.shelfIdMapWithMaxBuyNum[firstCategoryProduct.shelfId[0]].deliveryPrice - firstCategoryProduct.yingqiyu_categoryTotalPrice,
                        2
                    )}元起送`;
                }
            }
        },

        selectProduct(index)
        {
            this.selectProductList.splice(index, 1, !this.selectProductList[index]);
            
            //
            this.computeTotalPrice();

            //
            for(let item of this.selectProductList)
            {
                if(item == false)
                {
                    return this.ifSelectAll = false;
                }
            }

            this.ifSelectAll = true;
        },

        selectAll()
        {
            this.ifSelectAll = !this.ifSelectAll;

            for(let index = 0; index < this.selectProductList.length; index ++)
            {
                this.selectProductList.splice(index, 1, this.ifSelectAll)
            }

            this.computeTotalPrice();
        },

        commitOrder()
        {
            if(this.shopInfo.ifBusiness == 1)
            {
                return;
            }

            for(let item of this.productListWantPay)
            {
                if(item.yingqiyu_warning)
                {
                    return;
                }
            }
            
            //
            const productList = [];
            for(let index = 0; index < this.selectProductList.length; index ++)
            {
                if(this.selectProductList[index] == true)
                {
                    productList.push(this.cartInfo.shoppingCars[index]);
                }
            }
            if(productList.length == 0)
            {
                return this.Toast("请至少选择一件商品")
            }
            
            //
            this.payApiCommitOrder(
                this.shopId,
                productList,
                1
            )

            //
            this.removeDialog();
        },

        removeDialog() {
            this.remove();
        },

        clearCart() {
            this.axios.shop
                .get('/shoppingCarController/dumpShopingCar.do', {
                    shopId: this.shopId,
                })
                .then(({ statusCode, msg, data }) => {
                    if (statusCode !== '200') {
                        return this.Toast(`清空购物车失败, ${msg}`)
                    }

                    //
                    this.$store.commit("cart/clearCartInfo", this.shopId);
                })
                .catch((e) => {
                    this.Toast(e.toString())
                })
        },
    },
}
</script>

<style lang="scss" scoped>
$productSpecificationListFrameWidth: 85vw;
$productSpecificationListFrameHeight: 85vh;

$productSpecificationListFrameHeaderHeight: 50px;
$productSpecificationListFrameBottomHeight: 40px;

//
.shopCartMain {
    z-index: 1990;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    background-color: rgba(0, 0, 0, 0.7);;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: $fontSizeContent;
}

.frame {
    display: flex;
    flex-direction: column;
    width: $productSpecificationListFrameWidth;
    height: $productSpecificationListFrameHeight;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 10px;
}

//
.productSpecificationListFrameHeader {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-bottom: $margin;
}

//
.productSpecificationListFrameContent {
    flex-grow: 1;
    overflow-y: auto;
    .productWrapper
    {
        display: flex;
        align-items: center;
        overflow: hidden;
        .selector
        {
            width: 2em;
            min-width: 0;
            margin: 0;
            flex-shrink: 0;
        }
        .productOfCart
        {
            flex-grow: 1;
            overflow: hidden;
        }
    }
}

//
.productSpecificationListFrameBottom {
    flex-shrink: 0;

    .operatePanel
    {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}

</style>